import { Component, Input } from '@angular/core';

@Component({
  selector: 'yat-visible-input',
  templateUrl: './visible-input.component.html',
  styleUrls: ['./visible-input.component.scss']
})
export class VisibleInputComponent {
  @Input()
  content: string | undefined = undefined;

  @Input()
  inputElement: HTMLInputElement;

  showInput = false;

  toggleVisibility(): void {
    this.inputElement.type = this.inputElement.type === 'text' ? 'password' : 'text';
    this.showInput = !this.showInput;
  }
}
